import styled from 'styled-components'

import { helpers, toRem } from 'styles'

import { PointItem } from 'components/Layout'

type Props = {
	isCovered?: boolean
}

export const PolicyItem = styled(PointItem)<Props>`
	column-gap: 8px;
	align-items: center;
	font-size: ${helpers.font.size.base};
	color: ${helpers.color.text};
	padding: 0;

	& > svg {
		width: ${toRem(24)};
		height: ${toRem(24)};
		color: ${({ theme, isCovered = false }) => (isCovered ? theme.color.icon : theme.color.textLight)};
	}
`
